import PropTypes from "prop-types";
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

function ContractInfoCard({ data }) {
  if (!data) {
    return (
      <Card>
        <MDBox p={2}>
          <MDTypography variant="h6" fontWeight="medium">
            Informations Contrat
          </MDTypography>
          <MDBox mt={2}>
            <MDTypography variant="button" color="text">
              Aucune information disponible
            </MDTypography>
          </MDBox>
        </MDBox>
      </Card>
    );
  }

  // Calculer les jours restants pour la prochaine vérification
  const calculateDaysRemaining = () => {
    // Utiliser dateVerif si elle existe, sinon depart
    const referenceDate = data.dateVerif || data.depart;

    if (!referenceDate) return "N/A";

    // Parser la date (format: DD/MM/YYYY)
    const [day, month, year] = referenceDate.split("/");
    const refDate = new Date(year, month - 1, day);

    // Ajouter 30 jours
    const nextVerifDate = new Date(refDate);
    nextVerifDate.setDate(nextVerifDate.getDate() + 30);

    // Calculer la différence avec aujourd'hui
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    nextVerifDate.setHours(0, 0, 0, 0);

    const diffTime = nextVerifDate - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    return diffDays;
  };

  const daysRemaining = calculateDaysRemaining();
  const isUrgent = daysRemaining <= 7 && daysRemaining >= 0;
  const isOverdue = daysRemaining < 0;

  return (
    <Card>
      <MDBox p={2}>
        <MDBox mb={2}>
          <MDTypography variant="h6" fontWeight="medium">
            Informations Contrat
          </MDTypography>
          <MDTypography variant="button" color="text" fontWeight="regular">
            {data.nom}
          </MDTypography>
        </MDBox>

        <Divider />

        {/* Départ */}
        <MDBox mt={2}>
          <MDBox display="flex" justifyContent="space-between" mb={1}>
            <MDTypography variant="button" color="text" fontWeight="regular">
              Date de départ:
            </MDTypography>
            <MDTypography variant="button" fontWeight="bold">
              {data.depart || "N/A"}
            </MDTypography>
          </MDBox>
          <MDBox display="flex" justifyContent="space-between" mb={2}>
            <MDTypography variant="button" color="text" fontWeight="regular">
              KM départ:
            </MDTypography>
            <MDTypography variant="button" fontWeight="bold">
              {data.kmdepart?.toLocaleString() || "N/A"}
            </MDTypography>
          </MDBox>
        </MDBox>

        <Divider />

        {/* Dernière vérification */}
        <MDBox mt={2}>
          <MDBox display="flex" justifyContent="space-between" mb={1}>
            <MDTypography variant="button" color="text" fontWeight="regular">
              Dernière vérif:
            </MDTypography>
            <MDTypography variant="button" fontWeight="bold">
              {data.dateVerif || "Aucune"}
            </MDTypography>
          </MDBox>
          <MDBox display="flex" justifyContent="space-between" mb={2}>
            <MDTypography variant="button" color="text" fontWeight="regular">
              KM vérif:
            </MDTypography>
            <MDTypography variant="button" fontWeight="bold">
              {data.kmVERIF?.toLocaleString() || "N/A"}
            </MDTypography>
          </MDBox>
        </MDBox>

        <Divider />

        {/* Prochaine vérification */}
        <MDBox
          mt={2}
          p={2}
          sx={{
            backgroundColor: isOverdue
              ? "#ffebee"
              : isUrgent
              ? "#fff3e0"
              : "#e8f5e9",
            borderRadius: "8px",
          }}
        >
          <MDBox textAlign="center">
            <MDTypography variant="caption" color="text" fontWeight="regular">
              Prochaine vérification dans
            </MDTypography>
            <MDTypography
              variant="h3"
              fontWeight="bold"
              color={isOverdue ? "error" : isUrgent ? "warning" : "success"}
            >
              {daysRemaining >= 0 ? daysRemaining : Math.abs(daysRemaining)}
            </MDTypography>
            <MDTypography variant="button" color="text">
              {isOverdue ? "jours de retard" : "jours"}
            </MDTypography>
          </MDBox>
        </MDBox>
      </MDBox>
    </Card>
  );
}

ContractInfoCard.propTypes = {
  data: PropTypes.shape({
    nom: PropTypes.string,
    immat: PropTypes.string,
    depart: PropTypes.string,
    kmdepart: PropTypes.number,
    dateVerif: PropTypes.string,
    kmVERIF: PropTypes.number,
    dateretour: PropTypes.string,
    kmretour: PropTypes.number,
  }),
};

ContractInfoCard.defaultProps = {
  data: null,
};

export default ContractInfoCard;
